exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project.complete{border-left:4px solid green}.project.ongoing{border-left:4px solid orange}.project.overdue{border-left:4px solid red}", ""]);

// exports
